"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDimensionApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const dimensionQuery = (url, tag) => ({
    query: () => url,
    providesTags: [tag],
});
/**
 * Dimension API factory — see createTicketApi.ts for the shared-package baseQuery-injection
 * pattern. Only the ticket category/priority/urgency/status lookups plus the 11 lookups the
 * mobile ticket form's dropdowns need (resolution categories, centers, HST role recommendation,
 * job titles, issue types, application/PM categories, etc.) are ported here to match
 * Trackly.WebClient's DimensionService/dimensionApi.ts exactly; the rest of that service's other
 * lookups (access request, asset, vendor, compliance dimensions, job title/HST role mappings)
 * stay web-only until a client actually needs them.
 */
const createDimensionApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'dimensionApi',
    baseQuery,
    tagTypes: ['TicketDimensions', 'AssetDimensions'],
    endpoints: (builder) => ({
        getTicketCategories: builder.query(dimensionQuery('ticketCategories', 'TicketDimensions')),
        getTicketPriorities: builder.query({
            query: () => 'ticketPriorities',
            providesTags: ['TicketDimensions'],
        }),
        getTicketUrgencies: builder.query({
            query: () => 'ticketUrgencies',
            providesTags: ['TicketDimensions'],
        }),
        getTicketStatuses: builder.query({
            query: () => 'ticketStatuses',
            providesTags: ['TicketDimensions'],
        }),
        getResolutionCategories: builder.query({
            query: (ticketCategory) => ({
                url: 'resolutionCategories',
                params: ticketCategory ? { ticketCategory } : undefined,
            }),
            providesTags: ['TicketDimensions'],
        }),
        getCenters: builder.query({
            query: () => 'centers',
            providesTags: ['TicketDimensions'],
        }),
        getHstCenters: builder.query({
            query: () => 'centers/hst',
            providesTags: ['TicketDimensions'],
        }),
        getCpsiCenters: builder.query({
            query: () => 'centers/cpsi',
            providesTags: ['TicketDimensions'],
        }),
        getRecommendedHstRole: builder.query({
            query: (params) => ({
                url: 'recommendedHstRole',
                params,
            }),
            providesTags: ['TicketDimensions'],
        }),
        getHstRoles: builder.query({
            query: () => 'hstRoles',
            providesTags: ['TicketDimensions'],
        }),
        getJobTitles: builder.query({
            query: () => 'jobTitles',
            providesTags: ['TicketDimensions'],
        }),
        getIssueTypes: builder.query({
            query: () => 'issueTypes',
            providesTags: ['TicketDimensions'],
        }),
        getRepairableByOptions: builder.query({
            query: () => 'repairableByOptions',
            providesTags: ['TicketDimensions'],
        }),
        getApplicationTypes: builder.query({
            query: () => 'applicationTypes',
            providesTags: ['TicketDimensions'],
        }),
        getPmCategories: builder.query({
            query: () => 'pmCategories',
            providesTags: ['TicketDimensions'],
        }),
        getAssetCategories: builder.query(dimensionQuery('assetCategories', 'AssetDimensions')),
        getAssetStatuses: builder.query(dimensionQuery('assetStatuses', 'AssetDimensions')),
    }),
});
exports.createDimensionApi = createDimensionApi;
